import { render, staticRenderFns } from "./ShoppingCartList.vue?vue&type=template&id=3594b10d&scoped=true&"
import script from "./ShoppingCartList.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartList.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartList.vue?vue&type=style&index=0&id=3594b10d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3594b10d",
  null
  
)

export default component.exports